import API from '@/views/Fdc/Apis'
import ModelGrid from '@/views/Fdc/Detection/Components/ModelGrid'
import ModelConditionGrid from '@/views/Fdc/Detection/Components/ModelConditionGrid'
import LotsModal from '@/views/Fdc/Detection/Components/LotsModal'
import _ from 'lodash'
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Detection > Formula Detection
 * Formula Detection Model 관리
 */
export default {
  name: 'FormulaDetection',
  components: {
    'model-grid': ModelGrid, // Detection Model Grid component
    'model-condition-grid': ModelConditionGrid, // Detection Model Condition Grid component
    'lots-modal': LotsModal, // Select LOT Modal component
    'monaco-editor': MonacoEditor // Monaco Editor component
  },
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
    // rowData: function () {
    // }
  },
  methods: {
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Detection Model 목록 조회
     */
    searchModel () {
      this.$refs.modelGrid.searchModel()

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )
      BriqueChart.purge('formulaDetectionChart')
      this.initValue()
    },
    selectPrevNode () {
      let tempModelData = this.lastestSelectedNode
      if (tempModelData) {
        const model = this.$refs.modelGrid.$refs.modelGrd.gridApi.getModel()
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const node = model.getRow(i)
          if (node) {
            let { paramName, recipeId, stepId } = node.data
            if (
              paramName === tempModelData.paramName &&
              recipeId === tempModelData.recipeId &&
              stepId === tempModelData.stepId
            ) {
              console.log({ node })
              node.setSelected(true)
              this.lastestSelectedData = null
              break
            }
          }
        }
      }
    },
    initValue () {
      this.selectedModelData = {}
      this.selectedModelCondData = {}
      this.selectedLots = []
      this.chartData = []
      this.orgChartData = []
      this.lotsList = []
      this.orgLotsList = []
      this.scriptData = []
      this.settlingTime = null
      this.activationTime = null
      this.meanVal = null
      this.autoSpecFlag = false
      this.stdevVal = null
      this.uslVal = null
      this.uclVal = null
      this.lclVal = null
      this.lslVal = null
      this.uslSig = 2
      this.uclSig = 1
      this.lclSig = 1
      this.lslSig = 2
      this.fmlData = this.getFmlData('var y = 2 * x + 10;')
      this.yMin = null
      this.yMax = null
    },
    /**
     * AutoSpec Validation
     * @returns {Boolean} validation 성공 여부
     */
    isValidAutoSpec () {
      if (this.selectedModelData == null || !Object.keys(this.selectedModelData).length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
        return false
      }
      if (this.selectedLots == null || this.selectedLots.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Lots']))
        return false
      }
      if (this.chartData == null || this.chartData.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
        return false
      }
      return true
    },
    /**
     * Auto Spec 계산
     */
    async calcAutoSpec () {
      if (!this.isValidAutoSpec()) {
        return
      }

      const payload = {
        modelType: 'UVA',
        dataList: {
          uslSig: this.uslSig,
          uclSig: this.uclSig,
          lclSig: this.lclSig,
          lslSig: this.lslSig,
          paramName: this.selectedModelData.paramName,
          stepId: this.selectedModelData.stepId,
          chartValueList: this.lotsList,
          formulaDetectionChart: this.chartData,
          fmlData: this.fmlData,
          settlingTime: this.settlingTime,
          activationTime: this.activationTime
        }
      }

      const response = await API.Model.runFormulaAutoSpec(payload)
      if (response.status === 200) {
        this.meanVal = Math.round(response.data.mean * 10000) / 10000.0
        this.stdevVal = Math.round(response.data.stdev * 10000) / 10000.0
        this.uslVal = Math.round(response.data.uslOffset * 10000) / 10000.0
        this.uclVal = Math.round(response.data.uclOffset * 10000) / 10000.0
        this.lclVal = Math.round(response.data.lclOffset * 10000) / 10000.0
        this.lslVal = Math.round(response.data.lslOffset * 10000) / 10000.0

        this.scriptData = response.data.scriptValue.scriptChartData
        console.log(response.data.scriptValue)
        console.log('calcAutoSpec', this.scriptData)
        // this.drawChartTrandSeries()
        this.drawChartArea(true)
        // this.paramValVisible = 'Visible'
      }
    },
    /**
     * 차트 Series (ParamValue가 stepruntime별로 다르기 떄문에 따로 그림)
     */
    // drawChartSeries () {
    //   this.formulaChart.beginUpdate()
    //   this.formulaChart.series.splice(0, this.formulaChart.series.length)

    //   let series = new wjcChart.Series()
    //   series.name = 'Value'
    //   series.binding = 'paramValue'
    //   series.bindingX = 'stepRunTime'
    //   series.chartType = 'Scatter'
    //   series.symbolSize = 2
    //   this.formulaChart.series.push(series)

    //   this.formulaChart.endUpdate()
    // },
    /**
     * 차트 y축 영역 계산
     * @param {Boolean} valueVisible param value series vibile 여부
     */
    drawChartArea (valueVisible) {
      let traces = []
      this.chartData.forEach(trace => {
        trace.name = 'Value'
        trace.mode = 'markers'
        trace.type = 'scattergl'
        trace.hovertemplate = '<b>Sample Time:</b> %{x}<br><b>Lot ID:</b> %{text.lotId}<br><b>Value:</b> %{y:,}<br><b>Step Run Time:</b> %{text.stepRunTime}<extra></extra>'
        if (valueVisible) traces.push(trace)
      })

      this.scriptData.forEach(trace => {
        trace.mode = 'lines'
        if (trace.name === 'mean') trace.line = { color: 'yellowgreen' }
        else if (trace.name === 'UCL') trace.line = { color: 'orange' }
        else if (trace.name === 'LCL') trace.line = { color: 'orange' }
        else if (trace.name === 'USL') trace.line = { color: 'red' }
        else if (trace.name === 'LSL') trace.line = { color: 'red' }
        traces.push(trace)
      })

      // if (this.chartData.length > 2) {
      //   traces.push({
      //     name: 'value',
      //     x: this.chartData.map(element => element.stepRunTime),
      //     y: this.chartData.map(element => element.paramValue),
      //     mode: 'markers',
      //     type: 'scattergl',
      //     // visible: this.chartData.length > 2,
      //     hovertemplate: '<b>Sample Time:</b> %{x}<br><b>Lot ID:</b> %{text.lotId}<br><b>Value:</b> %{y:,}<br><b>Step Run Time:</b> %{text.stepRunTime}<extra></extra>',
      //     text: this.chartData
      //   })
      // }
      // traces.push({
      //   name: 'mean',
      //   x: this.scriptData.map(element => element.stepRunTime),
      //   y: this.scriptData.map(element => element.formulaDefValue),
      //   mode: 'lines',
      //   line: { color: 'yellowgreen' }
      // })
      // traces.push({
      //   name: 'UCL',
      //   x: this.scriptData.map(element => element.stepRunTime),
      //   y: this.scriptData.map(element => element.formulaUclValue),
      //   mode: 'lines',
      //   line: { color: 'orange' }
      // })
      // traces.push({
      //   name: 'LCL',
      //   x: this.scriptData.map(element => element.stepRunTime),
      //   y: this.scriptData.map(element => element.formulaLclValue),
      //   mode: 'lines',
      //   line: { color: 'orange' }
      // })
      // traces.push({
      //   name: 'USL',
      //   x: this.scriptData.map(element => element.stepRunTime),
      //   y: this.scriptData.map(element => element.formulaUslValue),
      //   mode: 'lines',
      //   line: { color: 'red' }
      // })
      // traces.push({
      //   name: 'LSL',
      //   x: this.scriptData.map(element => element.stepRunTime),
      //   y: this.scriptData.map(element => element.formulaLslValue),
      //   mode: 'lines',
      //   line: { color: 'red' }
      // })

      let layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hoverlabel: {
          align: 'left'
        },
        hovermode: 'closest'
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('formulaDetectionChart', traces, layout, config)

      // let yMin = 0
      // let yMax = 100
      // let margin = 0
      // var yValues = this.chartData.map(function (o) { return o.paramValue })

      // this.scriptData.forEach(data => {
      //   yValues.push(data.formulaDefValue)
      //   yValues.push(data.formulaUslValue)
      //   yValues.push(data.formulaUclValue)
      //   yValues.push(data.formulaLclValue)
      //   yValues.push(data.formulaLslValue)
      // })

      // yMax = Math.max(...yValues)
      // yMin = Math.min(...yValues)
      // margin = (yMax - yMin) * 0.2
      // this.yMin = yMin - margin
      // this.yMax = yMax + margin
    },
    /**
     * Detection Model 조회 (선택된 row)
     */
    async loadChartData () {
      const item = this.selectedModelData

      if (item === null) { return }
      if (item.briqueGridCud && item.briqueGridCud === 'C') { return }

      const payload = {
        fab: item.fab,
        eqpId: item.eqpId,
        moduleId: item.moduleId,
        paramName: item.paramName,
        recipeId: item.recipeId,
        stepId: item.stepId,
        uvaType: 'formula',
        modelType: 'uva'
      }
      await API.Model.getFormulaModel(payload, this.callback)
    },
    /**
     * Detection Model 조회 callback
     * @param {Object} item Detection Model 조회 결과
     */
    callback (item) {
      this.uslVal = item.uslOffset
      this.uclVal = item.uclOffset
      this.lclVal = item.lclOffset
      this.lslVal = item.lslOffset
      this.settlingTime = this.selectedModelData.settlingTime
      this.activationTime = this.selectedModelData.activationTime
      if (item.scriptValue) {
        this.fmlData = item.scriptValue.fmlData
        this.chartData = item.scriptValue.formulaDetectionChart
        this.scriptData = item.scriptValue.scriptChartData
        // this.chartData = item.scriptValue.chartValueList
        // this.scriptData = item.scriptValue.scriptValueList
      } else {
        this.fmlData = this.getFmlData('var y = 2 * x + 10;')
      }
      // chartdata bind 지연으로
      setTimeout(() => {
        if (item.scriptValue) {
          // this.drawChartTrandSeries()
          this.drawChartArea(false)
        }
      }, 30)
    },
    /**
     * Script Code Validation에 대한 Validation
     * @returns {Boolean} validation 성공 여부
     */
    isValidScript () {
      if (this.selectedModelData == null || !Object.keys(this.selectedModelData).length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
        return false
      }

      // if (this.selectedModelCondData == null || !Object.keys(this.selectedModelCondData).length) {
      //   this.$dialog.alert('Model Condition을 선택해 주세요.')
      //   return false
      // }

      if (this.fmlData == null || this.fmlData === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Script']))
        return false
      }

      if (this.selectedLots == null || this.selectedLots.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Lots']))
        return false
      }

      var isValid = function (that, value, name) {
        if (value == null || value === '' || !value > 0) {
          that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name]))
          return false
        }
        return true
      }
      return !(
        !isValid(this, this.uslVal, 'USL Offset') ||
        !isValid(this, this.uclVal, 'UCL Offset') ||
        !isValid(this, this.lclVal, 'LCL Offset') ||
        !isValid(this, this.lslVal, 'LSL Offset') ||
        !isValid(this, this.settlingTime.toString(), 'Settling Time') ||
        !isValid(this, this.activationTime.toString(), 'Activation Time')
      )
    },
    /**
     * Script Code Validation
     */
    async scriptValidataion () {
      if (!this.isValidScript()) {
        return
      }

      const payload = {
        modelType: 'UVA',
        dataList: {
          mean: this.meanVal,
          stdev: this.stdevVal,
          uslOffset: this.uslVal,
          uclOffset: this.uclVal,
          lclOffset: this.lclVal,
          lslOffset: this.lslVal,
          fmlData: this.fmlData,
          chartValueList: this.lotsList,
          formulaDetectionChart: this.chartData,
          settlingTime: this.settlingTime,
          activationTime: this.activationTime
        }
      }
      const response = await API.Model.runFormulaValid(payload)

      if (response.status === 200) {
        this.scriptData = response.data.scriptChartData
        // this.drawChartTrandSeries()
        this.drawChartArea(true)
        // this.paramValVisible = 'Visible'
      }
    },
    // drawChartTrandSeries () {
    //   this.formulaChart.beginUpdate()
    //   this.formulaChart.series.splice(1, this.formulaChart.series.length)
    //   let seriesAttrArr = [
    //     { name: 'Mean', binding: 'formulaDefValue' },
    //     { name: 'USL', binding: 'formulaUslValue' },
    //     { name: 'UCL', binding: 'formulaUclValue' },
    //     { name: 'LCL', binding: 'formulaLclValue' },
    //     { name: 'LSL', binding: 'formulaLslValue' }
    //   ]

    //   seriesAttrArr.forEach(seriesAttr => {
    //     let series = new wjcChart.Series()
    //     series.name = seriesAttr.name
    //     series.binding = seriesAttr.binding
    //     series.bindingX = 'stepRunTime'
    //     if (seriesAttr.name === 'USL' || seriesAttr.name === 'LSL') {
    //       series.style = { 'stroke-width': 1, 'stroke': '#ff0000' }
    //     } else if (seriesAttr.name === 'UCL' || seriesAttr.name === 'LCL') {
    //       series.style = { 'stroke-width': 1, 'stroke': '#ffa500' }
    //     } else if (seriesAttr.name === 'Mean') {
    //       series.style = { 'stroke-width': 1, 'stroke': '#01A9DB' }
    //     }
    //     series.itemsSource = this.scriptData
    //     this.formulaChart.series.push(series)
    //   })

    //   this.formulaChart.endUpdate()
    // },
    /**
     * Save Validation
     */
    isValidSaveData () {
      if (this.chartData == null || !this.chartData.length) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
        return false
      }

      if (this.fmlData == null || this.fmlData === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Script']))
        return false
      }

      var isValid = function (that, value, name) {
        if (value == null || !value > 0) {
          that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [name]))
          return false
        }
        return true
      }

      return !(!isValid(this, this.uslVal, 'USL') || !isValid(this, this.uclVal, 'UCL') || !isValid(this, this.lclVal, 'LCL') || !isValid(this, this.lslVal, 'LSL'))
    },
    /**
     * Detection Model 저장
     */
    async saveData () {
      if (!this.isValidSaveData()) {
        return
      }
      // TODO 저장 이후 Model조회 해주고 row 선택하는로직이 있어야 할 듯
      this.tmpSelectedModelData = this.selectedModelData
      let tempSelectedModelData = this.selectedModelData
      const payload = {
        modelType: 'UVA',
        dataList: [{
          fab: this.selectedModelData.fab,
          eqpId: this.selectedModelData.eqpId,
          moduleId: this.selectedModelData.moduleId,
          paramName: this.selectedModelData.paramName,
          recipeId: this.selectedModelData.recipeId,
          stepId: this.selectedModelData.stepId,
          uvaType: this.selectedModelData.uvaType,
          uslVal: this.uslVal,
          uclVal: this.uclVal,
          lclVal: this.lclVal,
          lslVal: this.lslVal,
          fmlData: this.fmlData,
          settlingTime: Number(this.settlingTime),
          activationTime: Number(this.activationTime)
        }]
      }

      const response = await API.Model.putPormulaModel(payload)
      if (response.status === 200 && response.data) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
        this.searchModel()
        this.lastestSelectedNode = tempSelectedModelData
        this.selectedModelData = this.tmpSelectedModelData
      }
    },
    /**
     * Select Lot Modal 열기
     */
    showLotsModal () {
      this.selectLotsModal.visible = this.selectedModelData !== null && Object.keys(this.selectedModelData).length > 0
      if (!this.selectLotsModal.visible) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
      }
    },
    /**
     * Select Lot Modal 닫기
     * @param {Boolean} value Modal 표시 여부
     */
    resetModalData (value) {
      this.selectLotsModal.visible = value
    },
    /**
     * Modal Apply Lot callback
     * @param {Array} list 선택된 lot 목록 배열
     */
    async applyLots (list) {
      this.scriptData = []
      this.selectedLots = list

      const payload = {
        modelType: 'UVA',
        dataList: {
          paramName: this.selectedModelData.paramName,
          stepId: this.selectedModelData.stepId,
          lotsList: this.selectedLots
        }
      }

      const response = await API.Model.getFormulaDatas(payload)
      if (response.status === 200 && response.data) {
        this.meanVal = null
        this.stdevVal = null
        this.uslVal = null
        this.uclVal = null
        this.lclVal = null
        this.lslVal = null
        // this.chartData = response.data.lotsList

        // this.orgChartData = response.data.lotsList
        // this.chartData = this.remakeChartData(response.data.lotsList)
        this.orgLotsList = response.data.lotsList
        this.lotsList = this.remakeLotsList(response.data.lotsList)
        this.orgChartData = response.data.formulaDetectionChart
        this.chartData = this.remakeChartData(response.data.formulaDetectionChart)

        // [2020.06] script 계산 process 변경해야 함 (settling time, activation time있을 때 변경)
        if (this.settlingTime === 0 && (this.activationTime === -1 || this.activationTime === 0)) {
          this.fmlData = this.getFmlData(response.data.scriptStr)
        } else {
          const payload = {
            modelType: 'UVA',
            dataList: {
              paramName: this.selectedModelData.paramName,
              stepId: this.selectedModelData.stepId,
              lotsList: this.lotsList,
              settlingTime: this.settlingTime,
              activationTime: this.activationTime
            }
          }
          const response = await API.Model.getFormulaScript(payload)
          if (response.status === 200 && response.data) {
            this.fmlData = this.getFmlData(response.data.scriptStr)
          }
        }
        // this.drawChartSeries()
        this.drawChartArea(true)
        // this.paramValVisible = 'Visible'

        if (this.autoSpecFlag) {
          this.calcAutoSpec()
          this.autoSpecFlag = false
        }
      }
    },
    /**
     * Modal Auto Spec callback
     */
    autoSpecLots () {
      this.autoSpecFlag = true
    },
    /**
     * Detection Model row selection event
     * @param {*} row Detection Model row data
     */
    setModelProps (row) {
      this.selectedModelData = row
      this.selectedModelCondData = {}
      this.selectedLots = []
      this.chartData = []
      this.orgChartData = []
      this.lotsList = []
      this.orgLotsList = []
      this.scriptData = []
      // this.paramValVisible = 'Hidden'
      // chart 초기화
      BriqueChart.purge('formulaDetectionChart')
      this.loadChartData()
    },
    /**
     * Detection Model Condition row selection event
     * @param {*} row
     */
    setModelConditionProps (row) {
      this.selectedModelCondData = row
      // this.selectedLots = []
      // this.chartData = []
    },
    /**
     * Javascript code data 동기화
     * @param {*} value javascript code data
     * Monaco Editor component의 data와 동기화합니다.
     */
    setCodeValue (value) {
      this.fmlData = value
    },
    /**
     * 기본 script code formatting
     * @param {*} scriptStr script code
     * @returns {*} script code
     */
    getFmlData (scriptStr) {
      return [
        '/*',
        ' * @param x : Step Run Time',
        ' * @desc',
        ' * (Caution)',
        ' * Do not change function name',
        ' */',
        'function fnCalculate(x) {',
        '\t' + scriptStr,
        '\treturn y;',
        '}'
      ].join('\n')
    },
    /**
     * Settling Time 변경 event
     */
    settlingTimeChange (val) {
      if (this.orgChartData.length > 0) {
        this.lotsList = this.remakeLotsList(this.orgLotsList)
        this.chartData = this.remakeChartData(this.orgChartData)
      }
      this.drawChartArea(true)
    },
    /**
     * Activation Time 변경 event
     */
    activationTimeChange (val) {
      if (this.orgChartData.length > 0) {
        this.lotsList = this.remakeLotsList(this.orgLotsList)
        this.chartData = this.remakeChartData(this.orgChartData)
      }
      this.drawChartArea(true)
    },
    /**
     * Chart Data 재구성
     * @param {*} orgChartData chart data
     * @returns {Array} 재구성된 chart data
     */
    remakeChartData (orgChartData) {
      let traces = []
      if (this.settlingTime !== null && this.activationTime !== null) {
        for (let trace of orgChartData) {
          let x = []
          let y = []
          let text = []
          for (let i in trace.text) {
            if (trace.text[i].stepRunTime >= this.settlingTime &&
              (Number(this.activationTime) === -1 || Number(this.activationTime) === 0 || trace.text[i].stepRunTime < (this.settlingTime + this.activationTime))) {
              x.push(trace.x[i])
              y.push(trace.y[i])
              text.push(trace.text[i])
            }
          }
          let newTrace = _.clone(trace)
          newTrace.x = x
          newTrace.y = y
          newTrace.text = text
          traces.push(newTrace)
        }
        return traces
      } else {
        return orgChartData
      }
      // let chartData = []
      // if (this.settlingTime !== null && this.activationTime !== null) {
      //   for (let i in orgChartData) {
      //     if (orgChartData[i].stepRunTime >= this.settlingTime &&
      //       (Number(this.activationTime) === -1 || Number(this.activationTime) === 0 || orgChartData[i].stepRunTime < (this.settlingTime + this.activationTime))) {
      //       chartData.push(orgChartData[i])
      //     }
      //   }
      //   // return chartData.length > 0 ? chartData : orgChartData
      //   return chartData
      // } else {
      //   return orgChartData
      // }
    },
    /**
     * Lots List 재구성
     * @param {*} orgLotsList lots list
     * @returns {Array} 재구성된 lots list
     */
    remakeLotsList (orgLotsList) {
      let lotsList = []
      if (this.settlingTime !== null && this.activationTime !== null) {
        for (let i in orgLotsList) {
          if (orgLotsList[i].stepRunTime >= this.settlingTime &&
            (Number(this.activationTime) === -1 || Number(this.activationTime) === 0 || orgLotsList[i].stepRunTime < (this.settlingTime + this.activationTime))) {
            lotsList.push(orgLotsList[i])
          }
        }
        return lotsList
      } else {
        return orgLotsList
      }
    },
    /**
     * 선택된 Detection Model이 있는지 여부 체크
     * @returns {Boolean}
     * Button 및 Textbox의 활성화를 제어합니다.
     */
    hasSelectedModelData () {
      if (this.selectedModelData === null) {
        return false
      } else if (Object.keys(this.selectedModelData).length === 0) {
        return false
      } else if (this.selectedModelData.briqueGridCud && this.selectedModelData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    },
    /**
     * Auto Formula 실행
     */
    async autoFormula () {
      // [2020.06] chartData 가지고 script 공식 구하는 logic 추가
      const payload = {
        modelType: 'UVA',
        dataList: {
          paramName: this.selectedModelData.paramName,
          stepId: this.selectedModelData.stepId,
          lotsList: this.lotsList,
          settlingTime: this.settlingTime,
          activationTime: this.activationTime
        }
      }
      const response = await API.Model.getFormulaScript(payload)
      if (response.status === 200 && response.data) {
        // this.meanVal = null
        // this.stdevVal = null
        // this.uslVal = null
        // this.uclVal = null
        // this.lclVal = null
        // this.lslVal = null

        this.fmlData = this.getFmlData(response.data.scriptStr)
        // this.drawChartSeries()
        this.drawChartArea(true)
        // this.paramValVisible = 'Visible'
      }
    }
  },
  data () {
    return {
      lastestSelectedNode: null,
      autoSpecFlag: false, // Auto Spec 실행하는지 여부
      meanVal: null, // Mean value
      stdevVal: null, // Stdev value
      uslVal: null, // USL Offset value
      uclVal: null, // UCL Offset value
      lclVal: null, // LCL Offset value
      lslVal: null, // LSL Offset value
      uslSig: 2, // USL Sigma value
      uclSig: 1, // UCL Sigma value
      lclSig: 1, // LCL Sigma value
      lslSig: 2, // LSL Sigma value
      fmlData: this.getFmlData('var y = 2 * x + 10;'), // Javascript code data
      yMin: null, // y축 Min value
      yMax: null, // y축 Max value
      chartData: [], // Formula chart data
      orgChartData: [], // Formula chart data
      lotsList: [], // lot data list
      orgLotsList: [], // lot data list
      scriptData: [], // Script Validation 결과 (Spec data)
      selectLotsModal: {
        visible: false
      }, // 기준정보 Copy Mode 표시 여부
      selectedLots: [], // Select Lot Modal에서 선택된 LOT 배열
      selectedTreeNode: [], // 선택된 EQP Tree node
      selectedModelData: {}, // 선택된 Detection Model
      selectedModelCondData: {}, // 선택된 Detection Model Condition
      tmpSelectedModelData: {}, // 선택된 Detection Model
      settlingTime: null, // Settling Time value
      activationTime: null, // Activation Time value
      editorOption: {
        lineNumbers: 'on'
        // colorDecorators: true,
        // parameterHints: {
        //   cycle: true,
        //   enabled: true
        // },
        // renderLineHighlight: 'all'
      } // Monaco Editor Option
      // paramValVisible: 'Hidden' // Value series visible 설정
    }
  }
}
